<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="职位详情">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-icon name="user-circle-o" size="24" @click="toHomePage" v-if="isManager === false"/>
          <van-icon name="more-o" size="24" v-if="isManager === true && isSameCompany === true"/>
        </template>
      </van-nav-bar>

      <van-row justify="space-between">
        <van-col class="job-title-name">
          <span>{{ jobInfo['title'] }}</span>
        </van-col>
        <van-col class="job-hits" v-if="isManager === true">
          <span>{{ hits }}浏览</span>
        </van-col>
      </van-row>
    </div>

    <div class="apply-body">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-row justify="space-between">
          <van-col class="job-content">
            <span>{{ jobInfo['company'] }}</span>
          </van-col>
          <van-col class="job-city">
            <span>{{ jobInfo['city'] }}</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col>
            <van-space>
              <van-tag plain type="primary" size="medium">{{ jobInfo['type'] }}</van-tag>
              <van-tag plain type="primary" size="medium">{{ jobInfo['education'] }}</van-tag>
            </van-space>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="job-content">
            <span>招聘人数：</span>
            <span v-if="jobInfo['number'] < 99">{{ jobInfo['number'] }}人</span>
            <span v-else>不限</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="job-content">
            <span>工作地点：</span>
            <span>{{ jobInfo['address'] }}</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="job-title">
            <van-icon name="arrow" color="#1989fa"/>
            <span>职位描述</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col class="job-content">
            <span v-if="jobInfo['description']" v-html="linefeed(jobInfo['description'])"/>
            <span v-else>暂无</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="job-title">
            <van-icon name="arrow" color="#1989fa"/>
            <span>专业方向</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col class="job-content">
            <span v-if="jobInfo['major']" v-html="linefeed(jobInfo['major'])"/>
            <span v-else>暂无</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="job-title">
            <van-icon name="arrow" color="#1989fa"/>
            <span>职位要求</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col class="job-content">
            <span v-if="jobInfo['requirement']" v-html="linefeed(jobInfo['requirement'])"/>
            <span v-else>暂无</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col class="job-title">
            <van-icon name="arrow" color="#1989fa"/>
            <span>福利待遇</span>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="8" v-for="benefit in benefitList" :key="benefit">
            <van-tag class="job-tag" round plain type="primary" size="medium">{{ benefit }}</van-tag>
          </van-col>
        </van-row>

        <van-button class="job-button" type="primary" round block icon="guide-o" @click="handleSubmit"
                    v-if="clickable === true && isManager === false">投递简历</van-button>
        <van-button class="job-button" type="primary" round block icon="guide-o" disabled plain
                    v-if="clickable === false && isManager === false">已投递</van-button>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {getUrlCode} from "@/api/common";
import {getJobHits, hitJob, isSubmitAble, submitResume} from "@/api";
import {showNotify} from "vant";

export default {
  name: "JobInfo",
  data() {
    return {
      loading: true,
      jobId: undefined,
      jobInfo: {},
      hits: undefined,
      benefitList: [],
      clickable: true,
      isManager: false,
      isSameCompany: false,
    }
  },
  mounted() {
    this.loading = true;
    this.jobId = this.$route.params['jobId'];
    this.jobInfo = JSON.parse(window.sessionStorage.getItem('jobInfo'));
    this.benefitList = this.jobInfo['benefit'].split('、');

    this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    if (this.userInfo === null || this.userInfo === undefined || this.userInfo === 'undefined') {
      hitJob('jobId=' + this.jobId).then(() => {
        getJobHits(this.jobId).then((res) => {
          if (res.code === 200) {
            this.hits = res.data;
          } else {
            this.hits = 0;
          }
        });
      });
      this.clickable = true;
      this.isManager = false;
      this.loading = false;
    } else {
      let userId = this.userInfo['id'];
      hitJob('jobId=' + this.jobId + '&userId=' + userId).then(() => {
        getJobHits(this.jobId).then((res) => {
          if (res.code === 200) {
            this.hits = res.data;
          } else {
            this.hits = 0;
          }
        });
      });
      if (this.userInfo['flag'] >= 0) {
        this.isManager = true;
        let companyIds = this.userInfo['companyId'].split(',');
        if (this.userInfo['flag'] === 0) {
          this.isSameCompany = true;
        } else if (this.jobInfo['companyId'] in companyIds) {
          this.isSameCompany = true;
        } else {
          this.isSameCompany = false;
        }
        this.loading = false;
      } else {
        this.isManager = false;
        isSubmitAble('jobId=' + this.jobId + '&userId=' + userId).then((res) => {
          if (res.code === 200) {
            this.clickable = res.data;
            this.loading = false;
          } else {
            this.clickable = true;
            this.loading = false;
            showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
          }
        });
      }
    }

    window.sessionStorage.removeItem('jump');
  },
  methods: {
    goBack() {
      this.$router.push('/JobList');
      window.sessionStorage.removeItem('jobInfo');
    },
    toHomePage() {
      this.$router.push('/HomePage');
      window.sessionStorage.setItem('back', '/JobInfo/' + this.jobId);
    },
    linefeed(content) {
      return content.replaceAll('\n', '<br>');
    },
    handleSubmit() {
      let code = getUrlCode().code;
      if (code === undefined || code === null) {
        this.toHomePage();
        window.sessionStorage.setItem('jump', '/JobInfo/' + this.jobId);
      } else {
        this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
        let resumeInfo = window.sessionStorage.getItem('userResume');
        if (resumeInfo === null || resumeInfo === undefined || resumeInfo === 'undefined') {
          window.sessionStorage.setItem('jump', '/JobInfo/' + this.jobId);
          this.$router.push('/ResumeForm');
        } else {
          //投递简历
          submitResume('jobId=' + this.jobId).then((res) => {
            if (res.code === 200) {
              this.clickable = false;
              //成功
              showNotify({ type: 'success', message: '简历投递成功！', position: 'bottom' });
            } else {
              showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
            }
          });
        }
      }
    },
  }
}
</script>

<style scoped>
.apply {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding: 0 16px 20px;
}

.job-title-name {
  font-size: 18px;
  padding-top: 10px;
  padding-left: 16px;
}

.job-hits {
  color: #969799;
  font-size: 14px;
  padding-top: 14px;
  padding-right: 16px;
}

.job-city {
  color: #969799;
}

.job-title {
  font-size: 18px;
  padding-top: 10px;
}

.job-content {
  font-size: 14px;
  line-height: 24px;
}

.job-tag {
  line-height: 28px;
  margin: 5px 10px;
}

.job-button {
  font-size: 18px;
  margin-top: 20px;
}

.van-row {
  padding-bottom: 12px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}
</style>